export default __webpack_public_path__ + "static/media/light_dark.80df3484.svg";